<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Report Summary</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /
      <b>Loyalty Point System</b>
      /
      <b>Report Summary</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12"></div>

      <div class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center">
        <span class="m-auto"></span>

        <div v-show="currentActiveTab === 1" class="btn-group" role="group" v-for="(button, index) in buttons"
          :key="index">
          <button :key="index" class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
            :class="{ 'change-background': button.status }" @click="onPressBtn(index, 'buttons')" type="button">
            {{ button.name }}
          </button>
        </div>

        <div v-show="currentActiveTab === 2" class="btn-group" role="group" v-for="(button, index) in customerButtons"
          :key="button.name">
          <button class="btn btn-secondary" id="btn-inactive" :press.sync="button.status"
            :class="{ 'change-background': button.status }" @click="onPressBtn(index, 'customerButtons')" type="button">
            {{ button.name }}
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" @click="currentActiveTab = 1">
              <a class="nav-link active" id="home-basic-tab" data-toggle="tab" href="#_active" role="tab"
                aria-controls="_active" aria-selected="true">Transaction</a>
            </li>
            <li class="nav-item" @click="currentActiveTab = 2">
              <a class="nav-link" id="profile-basic-tab" data-toggle="tab" href="#_inactive" role="tab"
                aria-controls="_inactive" aria-selected="false">Customer</a>
            </li>
          </ul>

          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active bg-white" id="_active" role="tabpanel"
              aria-labelledby="individual-tab">
              <div class="card-body">
                <div v-if="buttons[0].status">
                  <h4 class="card-title mb-3">
                    Points Earned Report
                    <b-button v-b-tooltip.hover.bottom :title="tooltipMsg" class="_tooltipCustom">
                      <img width="15" :src="require('@/assets/icons/i-icon.png')" />
                    </b-button>
                  </h4>




                  <div class="row">
                    <div class="col-7"></div>
                    <div class="col-5">
                      <div class="d-flex flex-row justify-content-between">
                        <label>Total Outstanding Liability (Users) in B$:</label>
                        <label>{{ outstanding_users }}</label>
                      </div>
                    </div>

                    <div class="col-7"></div>
                    <div class="col-5">
                      <div class="d-flex flex-row justify-content-between">
                        <label>Total Outstanding Liability <router-link
                            to="/lps/report/view/vendor">(Merchant)</router-link> in B$:</label>
                        <label>{{ outstanding_merchants }}</label>
                      </div>
                    </div>

                    <div class="col-7"></div>
                    <div class="col-5">
                      <div class="d-flex flex-row justify-content-between">
                        <label>Total Outstanding Liability <router-link to="/lps/charity">(Charity)</router-link> in
                          B$:</label>
                        <label>{{ outstanding_charities }}</label>
                      </div>
                    </div>

                    <div class="col-7"></div>
                    <div class="col-5">
                      <div class="d-flex flex-row justify-content-between">
                        <label>Total Outstanding Liability in
                          B$:</label>
                        <label>{{ total_liabilities }}</label>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <label><b>Date From</b></label>
                      <input type="date" class="form-control" v-model="dateFrom" />
                    </div>
                    <div class="col-6">
                      <label><b>Date To</b></label>
                      <input type="date" class="form-control" v-model="dateTo" />
                    </div>
                  </div>

                  <br />

                  <div class="text-left">
                    {{
          dateFromFormatted != null && dateToFormatted != null
            ? `Reported Date from ${dateFromFormatted} to ${dateToFormatted}`
            : ""
        }}
                  </div>

                  <div class="text-right">
                    <button class="btn btn-rounded btn-primary mr-2" style="width: 150px;" @click="filterSearch()">
                      Filter
                    </button>
                    <button class="btn btn-rounded btn-primary" style="width: 150px;" @click="resetFilter(1)">
                      Reset
                    </button>
                  </div>

                  <div class="table-responsive">
                    <table id="report_summary_table"
                      class="display table table-striped table-bordered summary-report-table"
                      style="width:180%; text-align: center;">
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Name</th>
                          <th>Points Earned</th>
                          <th>Points Earned in B$</th>
                          <th>Redeem Points</th>
                          <th>Redeem Points in B$</th>
                          <th>Expired Points</th>
                          <th>Expired Points in B$</th>
                          <th>Deleted Points</th>
                          <th>Deleted Points in B$</th>
                          <th>Available Points</th>
                          <th>Available Points in B$</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(list, index) in lists" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ list.name }}</td>
                          <td>{{ list.points_earned }}</td>
                          <td>{{ list.price_earned }}</td>
                          <td>{{ list.points_redeemed }}</td>
                          <td>{{ list.price_redeemed }}</td>
                          <td>{{ list.points_expired }}</td>
                          <td>{{ list.price_expired }}</td>
                          <td>{{ list.points_deleted }}</td>
                          <td>{{ list.price_deleted }}</td>
                          <td>{{ list.points_available }}</td>
                          <td>{{ list.price_available }}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td></td>
                          <td>Sub Total</td>
                          <td>{{ sub_total.points_earned }}</td>
                          <td>{{ sub_total.price_earned }}</td>
                          <td>{{ sub_total.points_redeemed }}</td>
                          <td>{{ sub_total.price_redeemed }}</td>
                          <td>{{ sub_total.points_expired }}</td>
                          <td>{{ sub_total.price_expired }}</td>
                          <td>{{ sub_total.points_deleted }}</td>
                          <td>{{ sub_total.price_deleted }}</td>
                          <td>{{ sub_total.points_available }}</td>
                          <td>{{ sub_total.price_available }}</td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <CharityPage v-if="buttons[1].status" :allCharities="allCharities" :resetFilter="resetFilter"
                  :filterSearchCharity="filterSearchCharity" :onfilterCharity="onfilterCharity"
                  :dateFromFormatted="dateFromFormatted" :dateToFormatted="dateToFormatted" :dateFrom="dateFrom"
                  :dateTo="dateTo" :charity_id="charity_id" :charities="charities" @onChangeDate="onChangeDate"
                  @onCharitySelected="onCharitySelected" />

                <TakafulProductPage v-if="buttons[2].status" :product_id="product_id"
                  @onProductSelected="onProductSelected" :allProducts="allProducts" :takafulProducts="takafulProducts"
                  :onfilterProduct="onfilterProduct" :filterSearchTakaful="filterSearchTakaful"
                  :resetFilter="resetFilter" :takaful_total_price="takaful_total_price"
                  :takaful_total_points="takaful_total_points" :dateFrom="dateFrom" :dateTo="dateTo"
                  @onChangeDate="onChangeDate" :dateFromFormatted="dateFromFormatted"
                  :dateToFormatted="dateToFormatted" />

                <VendorProductPage v-if="buttons[3].status" :selectedVendor="selectedVendor" :vendors="vendors"
                  :onfilter="onfilter" :dateFrom="dateFrom" :dateTo="dateTo" :dateFromFormatted="dateFromFormatted"
                  :dateToFormatted="dateToFormatted" :filterSearchProduct="filterSearchProduct"
                  :resetFilter="resetFilter" :vendorProducts="vendorProducts"
                  @onVendorProductSelected="onVendorProductSelected" @onChangeDate="onChangeDate" />

              </div>
            </div>


            <div class="tab-pane fade bg-white" id="_inactive" role="tabpanel" aria-labelledby="multiple-tab">
              <div class="card-body">
                <Customers :customerButtons="customerButtons" :currentActiveTab="currentActiveTab" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    </div>

  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CharityPage from './CharityPage.vue';
import TakafulProductPage from "./TakafulProductPage.vue";
import VendorProductPage from "./VendorProductPage.vue";
import Customers from "./Customers.vue";

export default {
  name: "report-summary",
  components: { Pagination, Loading, CharityPage, TakafulProductPage, VendorProductPage, Customers },

  data() {
    return {
      lists: [],
      charities: [],
      takafulProducts: [],

      takaful_total_points: 0,
      takaful_total_price: 0,

      vendors: [],
      vendorProducts: [],

      selectedVendor: null,

      allProducts: [],
      allCharities: [],

      product_id: null,

      charity_id: null,

      isLoading: false,
      fullPage: true,
      searchItem: null,

      buttons: [
        { status: true, name: "Report Summary" },
        { status: false, name: "Charity" },
        { status: false, name: "Takaful Product" },
        { status: false, name: "Vendor Product" }
      ],

      customerButtons: [
        { status: true, name: "Earned" },
        { status: false, name: "Redeemed" },
      ],

      dateFrom: null,
      dateTo: null,
      dateFromFormatted: null,
      dateToFormatted: null,

      currentActiveTab: 1,
      outstanding_users: '',
      outstanding_merchants: '',
      outstanding_charities: '',
      total_liabilities: '',

      tooltipMsg: 'E.g. For Summary Report, when trying to filter period 1st May 2024 - 6th Aug 2024, it will show the amount for period 1st May 2024 - 6th Aug 2024. However, for Total Outstanding Liability (Merchants) and Total Outstanding Liability (Charity), it will show the amount for period May 2024 - July 2024 instead',
      sub_total: null
    };
  },

  watch: {
    buttons: {
      async handler() {
        await this.loadData();
      },
      deep: true
    }
  },

  methods: {
    async loadSummary() {
      this.lists = [];
      this.sub_total = null;
      if (!this.checkToken()) {
        return;
      }
      try {
        let result = await axios.get(axios.lpsURL + `/report/summary/transactions`, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.lists = result.data.reports;
        this.outstanding_users = result.data.outstanding_users;
        this.outstanding_merchants = result.data.outstanding_merchants;
        this.outstanding_charities = result.data.outstanding_charities;
        this.total_liabilities = result.data.total_liabilities;
        this.tooltipMsg = result.data.tooltip;
        this.sub_total = result.data.sub_total
      } catch (e) {
        console.log(e);
      }
    },

    async loadCharity() {
      this.charities = [];
      this.charity_id = null;

      if (!this.checkToken()) {
        return;
      }
      try {
        let result = await axios.get(axios.lpsURL + `/report/summary/charity`, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.charities = result.data.charities;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadTakafulProduct() {
      this.takafulProducts = [];
      this.product_id = null;

      if (!this.checkToken()) {
        return;
      }
      try {
        let result = await axios.get(
          axios.lpsURL + `/report/summary/takaful/products`,
          {
            headers: {
              Authorization: "Bearer " + this.checkToken()
            }
          }
        );

        this.takafulProducts = result.data.products;
        this.takaful_total_price = result.data.total_price;
        this.takaful_total_points = result.data.total_points;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadVendorProducts() {
      this.vendorProducts = [];
      this.selectedVendor = null;

      if (!this.checkToken()) {
        this.isLoading = false;
        return;
      }
      try {
        let result = await axios.get(
          axios.lpsURL + `/report/summary/vendor/products`,
          {
            headers: {
              Authorization: "Bearer " + this.checkToken()
            }
          }
        );

        this.vendorProducts = result.data.products;
      } catch (e) {
        console.log(e);
      }
    },

    async loadVendor() {
      if (!this.checkToken()) {
        return;
      }
      try {
        let result = await axios.get(axios.lpsURL + `/vendor`, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        for (let i = 0; i < result.data.vendor.length; i++) {
          if (result.data.vendor[i].id !== 1) {
            this.vendors.push(result.data.vendor[i]);
          }
        }
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadVendorProduct() {
      this.vendorProducts = [];

      if (!this.checkToken()) {
        this.isLoading = false;
        return;
      }
      try {
        let result = await axios.get(
          axios.lpsURL +
          `/report/summary/vendor/products?vendor=${this.selectedVendor}`,
          {
            headers: {
              Authorization: "Bearer " + this.checkToken()
            }
          }
        );

        this.vendorProducts = result.data.products;
      } catch (e) {
        console.log(e);
      }
    },

    async onfilter() {
      this.destroyDatatable();
      this.isLoading = true;
      await this.loadVendorProduct();
      this.isLoading = false;

      $("#vendor_product_summary_table").DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5"
          },
          {
            extend: "pdfHtml5"
          }
        ]
      });
    },

    async loadFilteredData() {
      if (!this.checkToken()) {
        return;
      }

      let url = "";

      if (this.dateFrom == null && this.dateTo == null) {
        url = `/report/summary/transactions`;
      } else {
        url = `/report/summary/transactions?date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      }

      this.dateFromFormatted = moment(this.dateFrom).format("DD MMMM YYYY");
      this.dateToFormatted = moment(this.dateTo).format("DD MMMM YYYY");

      try {
        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.lists = result.data.reports;
        this.outstanding_users = result.data.outstanding_users;
        this.outstanding_merchants = result.data.outstanding_merchants;
        this.outstanding_charities = result.data.outstanding_charities;
        this.total_liabilities = result.data.total_liabilities;
        this.sub_total = result.data.sub_total
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadfilterProduct() {
      if (!this.checkToken()) {
        return;
      }

      let url = "";

      if (this.dateFrom == null && this.dateTo == null) {
        url = `/report/summary/vendor/products`;
      } else {
        url = `/report/summary/vendor/products?date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      }

      if (
        this.selectedVendor != null &&
        this.dateFrom != null &&
        this.dateTo != null
      ) {
        url = `/report/summary/vendor/products?vendor=${this.selectedVendor}&date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      }

      this.dateFromFormatted = moment(this.dateFrom).format("DD MMMM YYYY");
      this.dateToFormatted = moment(this.dateTo).format("DD MMMM YYYY");

      try {
        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.vendorProducts = result.data.products;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadfilterProductByName() {
      if (!this.checkToken()) {
        return;
      }

      let url = "";

      if (this.product_id == null) {
        url = `/report/summary/takaful/products`;
      } else {
        url = `/report/summary/takaful/products?product_id=${this.product_id}`;
      }

      try {
        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.takafulProducts = result.data.products;
        this.takaful_total_price = result.data.total_price;
        this.takaful_total_points = result.data.total_points;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadfilterCharityByName() {
      if (!this.checkToken()) {
        return;
      }

      let url = "";

      if (this.charity_id == null) {
        url = `/report/summary/charity`;
      } else {
        url = `/report/summary/charity?charity_id=${this.charity_id}`;
      }

      try {
        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.charities = result.data.charities;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadAllProducts() {
      if (!this.checkToken()) {
        return;
      }

      let prod_id_array = [1, 2, 3, 4, 5, 6, 9, 10, 11, 12, 14, 15];

      try {
        let result = await axios.get(`/products`, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        result.data.forEach(element => {
          if (prod_id_array.includes(element.id)) {
            this.allProducts.push({ id: element.id, name: element.name });
          }
        });
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadAllCharities() {
      if (!this.checkToken()) {
        return;
      }

      try {
        let result = await axios.get(axios.lpsURL + `/charity/get`, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        result.data.charities.forEach(element => {
          this.allCharities.push({ id: element.id, name: element.name });
        });
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadFilterCharity() {
      if (!this.checkToken()) {
        return;
      }

      let url = "";

      if (this.dateFrom == null && this.dateTo == null) {
        url = `/report/summary/charity`;
      } else {
        url = `/report/summary/charity?date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      }

      if (
        this.charity_id != null &&
        this.dateFrom != null &&
        this.dateTo != null
      ) {
        url = `/report/summary/charity?charity_id=${this.charity_id}&date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      }

      this.dateFromFormatted = moment(this.dateFrom).format("DD MMMM YYYY");
      this.dateToFormatted = moment(this.dateTo).format("DD MMMM YYYY");

      try {
        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.charities = result.data.charities;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadFilterTakafulProduct() {
      if (!this.checkToken()) {
        return;
      }

      let url = "";

      if (this.dateFrom == null && this.dateTo == null) {
        url = `/report/summary/takaful/products`;
      } else {
        url = `/report/summary/takaful/products?date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      }

      if (
        this.product_id != null &&
        this.dateFrom != null &&
        this.dateTo != null
      ) {
        url = `/report/summary/takaful/products?product_id=${this.product_id}&date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      }

      this.dateFromFormatted = moment(this.dateFrom).format("DD MMMM YYYY");
      this.dateToFormatted = moment(this.dateTo).format("DD MMMM YYYY");

      try {
        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.takafulProducts = result.data.products;
        this.takaful_total_price = result.data.total_price;
        this.takaful_total_points = result.data.total_points;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async filterSearch() {
      this.isLoading = true;
      this.destroyDatatable();
      await this.loadFilteredData();
      this.setDatatable();
      this.isLoading = false;
    },

    async filterSearchProduct() {
      this.isLoading = true;
      this.destroyDatatable();
      await this.loadfilterProduct();
      this.setDatatable();
      this.isLoading = false;
    },

    async filterSearchCharity() {
      this.isLoading = true;
      this.destroyDatatable();
      await this.loadFilterCharity();
      this.setDatatable();
      this.isLoading = false;
    },

    async filterSearchTakaful() {
      this.isLoading = true;
      this.destroyDatatable();
      await this.loadFilterTakafulProduct();
      this.setDatatable();
      this.isLoading = false;
    },

    async onfilterProduct() {
      this.isLoading = true;
      this.destroyDatatable();
      await this.loadfilterProductByName();
      this.setDatatable();
      this.isLoading = false;
    },

    async onfilterCharity() {
      this.isLoading = true;
      this.destroyDatatable();
      await this.loadfilterCharityByName();
      this.setDatatable();
      this.isLoading = false;
    },

    checkToken() {
      let token = localStorage.getItem("token");

      if (token === null || token === "") {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },

    async setDatatable() {
      $(".report-table").DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            messageTop:
              this.dateTo != null && this.dateFrom != null
                ? `Reported Date from ${this.dateFromFormatted} to ${this.dateToFormatted}`
                : ""
          },
          {
            extend: "pdfHtml5",
            orientation: 'landscape',
          }
        ]
      });
      const summaryTable = $("#report_summary_table").DataTable({
        pageLength: 10,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            messageTop:
              this.dateTo != null && this.dateFrom != null
                ? `Reported Date from ${this.dateFromFormatted} to ${this.dateToFormatted}`
                : ""
          },
          {
            extend: "pdfHtml5",
            orientation: 'landscape',
          }
        ]
      });


    },


    destroyDatatable() {
      $(".report-table")
        .DataTable()
        .destroy();

      $("#report_summary_table")
        .DataTable()
        .destroy();

      $("#charity_report_summary_table")
        .DataTable()
        .destroy();

      $("#takaful_product_summary_table")
        .DataTable()
        .destroy();

      $("#vendor_product_summary_table")
        .DataTable()
        .destroy();
    },

    onPressBtn(int, buttonArray) {
      this[buttonArray].forEach((button, index) => (button.status = int === index));
      this.dateFrom = null;
      this.dateTo = null;
      this.charity_id = null;
      this.product_id = null;
      this.dateFromFormatted = null;
      this.dateToFormatted = null;
      this.selectedVendor = null;
    },

    async resetFilter(int) {
      this.destroyDatatable();
      this.isLoading = true;

      switch (int) {
        case 1:
          await this.loadSummary();
        case 2:
          await this.loadCharity();
        case 3:
          await this.loadTakafulProduct();
        case 4:
          await this.loadVendorProducts();
      }

      this.dateFrom = null;
      this.dateFromFormatted = null;
      this.dateTo = null;
      this.dateToFormatted = null;
      this.charity_id = null;
      this.product_id = null;
      this.selectedVendor = null;
      this.setDatatable();

      this.isLoading = false;
    },

    onProductSelected(e) {
      this.product_id = e;
    },

    onCharitySelected(e) {
      this.charity_id = e;
    },

    onVendorProductSelected(e) {
      this.selectedVendor = e;
    },

    onChangeDate(e, type) {
      if (type == 1) {
        this.dateFrom = e;
      } else if (type == 2) {
        this.dateTo = e;
      }
    },

    checkActiveButtons() {
      const activeButton = this.buttons.findIndex(button => button.status)
      return activeButton;
    },

    async loadData() {
      const active = this.checkActiveButtons();
      this.isLoading = true;
      this.destroyDatatable();

      switch (active) {
        case 0:
          await this.loadSummary();
        case 1:
          await this.loadCharity();
        case 2:
          await this.loadTakafulProduct();
        case 3:
          await this.loadVendorProducts();
      }


      this.setDatatable();
      this.isLoading = false;
    },

  },

  async created() {
    this.isLoading = true;
    await this.loadSummary();
    await this.loadVendor();
    await this.loadAllProducts();
    await this.loadAllCharities();
    this.setDatatable();
    this.isLoading = false;
  }
};
</script>

<style>
.spanDateTime {
  display: none;
}

.change-background {
  background-color: #5f5f5f;
  color: white;
}

.summary-report-table td:nth-child(3) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table th:nth-child(3) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table td:nth-child(5) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table th:nth-child(5) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table td:nth-child(7) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table th:nth-child(7) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table td:nth-child(9) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table th:nth-child(9) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table td:nth-child(11) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table th:nth-child(11) {
  border-left-width: 2px !important;
  border-left-color: black !important;
}

.summary-report-table td:nth-child(12) {
  border-right-width: 2px !important;
  border-right-color: black !important;
}

.summary-report-table th:nth-child(12) {
  border-right-width: 2px !important;
  border-right-color: black !important;
}

.summary-report-table tbody tr:last-child td:nth-child(n+3) {
  border-bottom: 2px !important;
  border-bottom: solid black !important;
}

.summary-report-table thead th:nth-child(n+3) {
  border-top: 2px !important;
  border-top: solid black !important;
}

._tooltipCustom {
  cursor: default;
}

._tooltipCustom:hover {
  cursor: pointer;
}
</style>
